<template>
  <div style="width: 100px;">
    <el-card :body-style="{ padding: '0px' }">

      <el-image style="width: 100px; height: 132px" :src="photo" fit="cover">
      </el-image>

      <div style="padding: 14px;">
        <span>{{data.personnel.personnel_name}}</span>
        <div class="bottom clearfix">
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Common from '../../../../js/Common'

export default {
  name: 'PersonnelItem',
  props: {
    data: Object
  },
  data () {
    return {
      photo: Common.getPersonnelPhoto(this.data.personnel.id)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/PersonnelItem.vue